import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { MFormulaBlockComponent } from './formula-block.component';

@NgModule({
  imports: [CommonModule, NzIconModule],
  exports: [MFormulaBlockComponent],
  declarations: [MFormulaBlockComponent]
})
export class MFormulaBlockModule {}
